import {Component, Input, OnInit} from '@angular/core';
import {customColumnsAffectation, customColumnsPersonnel, randomData} from "../sites-adresses/data/datable.data";
import {MatDialog} from "@angular/material/dialog";
import {
  AddServicesAffectationComponent
} from "./components/add-services-affectation/add-services-affectation.component";
import {Establishment} from "../../../../../models/Establishment";
import {AffectationService} from "../../../../../services/affectation.service";
import {FormBuilder} from "@angular/forms";
import {AuthService} from "../../../../../services/auth.service";
import {debounceTime} from "rxjs";

@Component({
  selector: 'app-services-affectation',
  templateUrl: './services-affectation.component.html',
  styleUrl: './services-affectation.component.scss'
})
export class ServicesAffectationComponent implements OnInit {
  @Input() establishment: Establishment;

  affectationList: any[] = []
  loading = false;
  offset = 0;
  limit = 10;
  form = this.fb.group({
    keyword: [''],
    etablissementId: this.auth.id,
    offset: this.offset,
    limit: this.limit,
  })
  totalItems: number
    constructor(private dialog: MatDialog,
                private affectationService: AffectationService,
                private fb: FormBuilder,
                private auth: AuthService) {
    }

  ngOnInit() {
    // this.getAffectationServices();
    this.form.get('keyword')?.valueChanges.pipe(debounceTime(700)).subscribe(() => {
        this.getAffectationServices()
    })
    this.affectationService.getRefreshData().subscribe({
      next: value => {
        this.getAffectationServices();
      }
    })
  }

  getAffectationServices() {
    this.loading = true;
      this.affectationService.affectationServiceFilter(this.form.value, "/v2").subscribe({
        next: ({content, totalElements}) => {
          this.affectationList = content
          this.totalItems = totalElements;
          this.loading = false;
        }
      })
  }

  openAddServiceAffectationDialog() {
    const dialog = this.dialog.open(AddServicesAffectationComponent, {
      width: '700px',
      autoFocus: false,
      data: {
        isModify: false
      }
    })
    dialog.afterClosed().subscribe(value => {
      if (value) {
        this.getAffectationServices()
      }
    })
  }
  pagination(event: any) {
    // this.offset = event.pageIndex * this.limit;
    this.form.get('offset')?.patchValue(event.pageIndex)
    // this.form.get('limit')?.patchValue(event.pageIndex)
    this.getAffectationServices();
  }

  protected readonly customColumnsAffectation = customColumnsAffectation;
}
